import GoIcon from "./icons/GoIcon";
import PythonIcon from "./icons/PythonIcon";
import JavascriptIcon from "./icons/JavascriptIcon";
import ReactIcon from "./icons/ReactIcon";
import TailwindIcon from "./icons/TailwindIcon";
import GitIcon from "./icons/GitIcon.jsx";
import ThreejsIcon from "./icons/ThreejsIcon.jsx";
import DockerIcon from "./icons/DockerIcon";
import FlutterIcon from "./icons/FlutterIcon";
import FastapiIcon from "./icons/FastapiIcon";
import RestApiIcon from "./icons/RestApiIcon";
import WebsocketIcon from "./icons/WebsocketIcon";
import LinuxIcon from "./icons/LinuxIcon";


const skillsData = {
    "Languages": [
        "Go",
        "Python",
        "Javascript"
    ],

    "Backend & Cloud": [
        "FastAPI",
        "Docker",
        "WebSocket"
    ],

    "Frontend & Mobile": [
        "ThreeJS",
        "React",
        "Tailwind",
        "Flutter"
    ],

    "Tools": [
        "Git",
        "Linux"
    ],
};

const skillIcons = {
    Go: <GoIcon className="size-9" />,
    Python: <PythonIcon className="size-9" />,
    Javascript: <JavascriptIcon className="size-9" />,

    React: <ReactIcon className="size-9" />,
    Tailwind: <TailwindIcon className="size-9" />,
    ThreeJS: <ThreejsIcon className="h-10 w-auto" />,
    Flutter: <FlutterIcon className="size-9" />,

    FastAPI: <FastapiIcon className="size-9" />,
    Docker: <DockerIcon className="size-9" />,
    RestApi: <RestApiIcon className="size-9" />,
    WebSocket: <WebsocketIcon className="size-9" />,

    Git: <GitIcon className="size-10" />,
    Linux: <LinuxIcon className="size-10" />,
};


export default function SkillsContent() {
    return (
        <div className="backdrop-blur-[7px] rounded-sm p-6 shadow-glow pointer-events-auto">
            <h1 className="text-3xl font-bold mb-2">Skills</h1>
            <div className="grid gap-2">
                {Object.entries(skillsData).map(([category, skills], index) => (
                    <div
                        key={index}
                        className="p-4 rounded-sm"
                    >
                        <h2 className="text-xl font-bold text-sky-300 mb-3">
                            {category}
                        </h2>
                        <div className="cursor-default flex flex-wrap gap-2 items-center justify-center">
                            {skills.map((skill, i) => (
                                <span
                                    key={i}
                                    className="grid grid-cols-1 place-items-center cursor-default pointer-events-auto transition-transform hover:scale-105 hover:shadow-glow-lg hover:rounded-sm border-1 border-gray-800 text-gray-200 text-base font-medium px-4 py-2 rounded-sm"
                                >
                                    {skillIcons[skill]}
                                    <div className="mt-1 text-xs text-white">
                                        {skill}
                                    </div>
                                </span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
